<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            fullscreen
            content-class="d-flex justify-center align-center"
        >
            <div
                class="d-flex flex-column justify-center align-center elevation-15 success-content"
                id="success-modal"
            >
                <div class="d-flex flex-column justify-center align-center position-relative">
                    <div
                        class="p-img d-flex flex-column justify-center align-center position-absolute"
                        :style="'top: -13vh;'"
                    >
                        <img :src="varitaImg" alt="pistas imagen de modal" />
                    </div>
                    <div class="pa-5 mx-5 mt-10">
                        <span class="text-h4 white--text pa-5 font-weight-lighter">
                            {{
                                success
                                    ? $t('challenge.very_well_done')
                                    : $t('challenge.result_msg_0')
                            }}
                        </span>
                    </div>
                    <div class="px-5 mx-5">
                        <span class="white--text text-body-1">
                            {{ success ? $t('challenge.success_msg') : $t('challenge.fail_msg') }}
                        </span>
                        <div class="mt-15 d-flex justify-center flex-row align-center">
                            <div
                                class="position-relative text-center mx-8 d-flex justify-center align-center"
                            >
                                <span
                                    class="text-beecoin z-text bright-points"
                                    style="margin-left: 14px"
                                >
                                    {{ pointsWon }}
                                    <br />{{ $t('challenge.initial_text_points') }}
                                </span>
                                <div class="position-absolute">
                                    <img
                                        src="/img/user/bright-points.svg"
                                        class="bright-points bee-icon-size"
                                        alt="point icon"
                                    />
                                </div>
                            </div>
                            <div
                                class="position-relative text-center mx-8 d-flex justify-center align-center"
                            >
                                <span class="text-beecoin z-text bright-beecoin">
                                    {{ coinsWon }}
                                    <br />Beecoins
                                </span>
                                <div class="position-absolute">
                                    <img
                                        src="/img/user/bright-beecoin.svg"
                                        class="bright-beecoin bee-icon-size"
                                        alt="coin icons"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-card-actions class="d-flex justify-center align-center ma-4 mt-12">
                        <v-spacer></v-spacer>
                        <v-btn  data-cy="challengeSuccessModal-exit-button" color="white" class="px-10 py-5" rounded outlined @click="exit">
                            {{ $t('exit') }}
                        </v-btn>
                        <v-btn data-cy="challengeSuccessModal-newChallenge-button" color="secondary" class="px-5 py-5" rounded @click="newChallenge">
                            {{ $t('challenge.new_challenge') }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </div>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_beecoins: { type: [String, Number], default: 0 },
        wildcard_price: { type: [String, Number], default: 0 },
        coinsWon: { type: [String, Number], default: 0 },
        pointsWon: { type: [String, Number], default: 0 },
        success: { type: Boolean, default: false },
    },
    data() {
        return {
            varitaImg: require('@/assets/img/icons/beecoins-1.svg'),
        }
    },
    methods: {
        exit() {
            this.$emit('exit-challenge')
        },
        newChallenge() {
            this.$emit('new-challenge')
            window.ChurnZero.push(['trackEvent', 'newChallenge', 'load a new challenge']);
            this.$ga.event('pageLoaded', 'newChallenge')
        },
    },
    computed: {
        msg_beecoins() {
            return `${this.$t('bookReading.have')} ${this.count_beecoins} ${this.$t('beecoins')}`
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.success-content {
    width: 35%;
    border: 20px solid #5d5286;
    border-radius: 26px;
    background: linear-gradient(146.1deg, #6d5bb0 0%, #b5a1eb 100%);
    /* height: 40vh; */
}
.items-unset {
    align-items: unset !important;
}

.bright-points {
    align-items: center;
    color: #816ad6;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}
.bee-icon-size {
    width: 16.5vh;
}
.bee-icon-size-2 {
    width: 17.5vh;
}
.z-text {
    z-index: 10;
}
</style>
